module.exports = __webpack_public_path__ + "img/Julia1.3bb1e69d.png";